export const emptyArray = Object.freeze([]);

export const emptyObject = Object.freeze({});
